import type { AssistantAction, AssistantBooking } from './api';

export const assistantMemberPath = (memberId: string): string =>
  `/assistant/members/${encodeURIComponent(memberId)}`;

export const assistantActionPath = (
  memberId: string,
  appointmentId: string,
  action: AssistantAction,
): string =>
  `${assistantMemberPath(memberId)}/appointments/${encodeURIComponent(appointmentId)}/${action}`;

export const assistantBookPath = (
  memberId: string,
  coachPersonId: string,
  booking: AssistantBooking,
): string =>
  `${assistantMemberPath(memberId)}/book/${encodeURIComponent(coachPersonId)}?booking=${booking}`;
